import storeManager from './storeManager';

const getStore = () =>
  storeManager.store;

export default getStore;